import { Injectable } from '@angular/core'

import { Observable, catchError, map, throwError } from 'rxjs'

import {
  GetBiztelPhoneNumberTagMappingsGQL,
  GetBiztelPhoneNumberTagMappingsQuery,
  SaveBiztelPhoneNumberTagMappingsGQL,
  SaveBiztelPhoneNumberTagMappingsInput,
} from '../../../../_generated/graphql'
import { assertGraphqlData } from '../../../util/assertGraphqlData'
import { throwIfCustomError } from '../../../util/throwIfCustomError'

export type BiztelPhoneNumberTagMappingView =
  GetBiztelPhoneNumberTagMappingsQuery['getAdminOrg']['biztelPhoneNumberTagMappings'][number]

@Injectable({
  providedIn: 'root',
})
export class BiztelPhoneNumberTagMappingService {
  constructor(
    private getBiztelPhoneNumberTagMappingsGQL: GetBiztelPhoneNumberTagMappingsGQL,
    private saveBiztelPhoneNumberTagMappingsGQL: SaveBiztelPhoneNumberTagMappingsGQL,
  ) {}

  getBiztelPhoneNumberTagMappings(): Observable<
    BiztelPhoneNumberTagMappingView[]
  > {
    return this.getBiztelPhoneNumberTagMappingsGQL
      .fetch({ fetchPolicy: 'no-cache' })
      .pipe(
        map((res) => {
          assertGraphqlData(res)
          return res.data.getAdminOrg.biztelPhoneNumberTagMappings
        }),
        catchError((error: unknown) => {
          throwIfCustomError(error)
          return throwError(() => error)
        }),
      )
  }

  // 保存は org 単位の全置換 (着信・発信まとめて 1 回。mappings: [] は全削除)。
  saveBiztelPhoneNumberTagMappings(
    input: SaveBiztelPhoneNumberTagMappingsInput,
  ): Observable<true> {
    return this.saveBiztelPhoneNumberTagMappingsGQL
      .mutate({ variables: { input }, fetchPolicy: 'no-cache' })
      .pipe(
        map((res) => {
          assertGraphqlData(res)
          // Boolean! 契約上サーバーは成功時 true を返す。false / data 欠落を
          // 正常値として流すと呼び出し側が成功通知を出してしまうため throw する。
          if (res.data.saveBiztelPhoneNumberTagMappings !== true) {
            throw new Error(
              'saveBiztelPhoneNumberTagMappings が成功を返しませんでした',
            )
          }
          return true as const
        }),
        catchError((error: unknown) => {
          throwIfCustomError(error)
          return throwError(() => error)
        }),
      )
  }
}
